(function($) {

	'use strict';

	function init(){
		closeBanner()
		toggleTarget()
		swiperServices()
		initEventSlider()
	};

	function initEventSlider() {
		const eventSwiper = new Swiper('.fpEvents__swiper .swiper-container', {
			// loop: false,
			// autoplay: false,
			// slidesPerView: 1,
			// spaceBetween: 15,
			// centeredSlides: false,
			// navigation: {
			// 	prevEl: '.fpEvents__swiper__prev',
			// 	nextEl: '.fpEvents__swiper__next',
			// },


			// Optional parameters
			loop: false,
			autoplay: false,
			slidesPerView: 1,
			spaceBetween: 15,

			// Navigation arrows
			navigation: {
				nextEl: '.fpEvents__swiper__nav--next',
				prevEl: '.fpEvents__swiper__nav--prev',
			},

			breakpoints: {
				768: {
					slidesPerView: 2,
				}
			}
		});
	}


	function closeBanner(){

		$('.fpHero__banner__close').click(function(){
			$('.fpHero__banner').removeClass('active')
		})

	}

	function toggleTarget(){

		$('.fpHero__content__btn').click(function(){

			$('.fpHero__target').toggleClass('active')

		})

	}

	function swiperServices(){

		const swiper = new Swiper('.fpServices__swiper .swiper-container', {
			// Optional parameters
			loop: false,
			autoplay: false,
			slidesPerView: 1.5,
			spaceBetween: 15,
			centeredSlides: true,

			// Navigation arrows
			navigation: {
				nextEl: '.fpServices__swiper__nav--next',
				prevEl: '.fpServices__swiper__nav--prev',
			},

			breakpoints: {
				768: {
				  centeredSlides: false,
				  slidesPerView: 2.5,
				},
				992: {
					slidesPerView: 3.5,
					centeredSlides: false,
				}
			}

		});

	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
